
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Container, Card, Form, Button, Alert, Spinner } from '@themesberg/react-bootstrap';
import { Routes } from "../../routes";
import { getDefaultLandingPath, updateFaviconAndTitle } from "../../utils/access";

export default () => {
  const history = useHistory();
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.username || !formData.password) {
      setError("Veuillez remplir tous les champs.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const API_BASE = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? window.location.origin : 'https://sgrloto.com';

      const response = await fetch(`${API_BASE}/api/login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password,
        }),
      });


      const data = await response.json();

      if (response.ok && data.access) {
        // Agents POS : pas d'accès au frontend web
        if (data.role === "AGENT") {
          setError("Les agents doivent utiliser l'application mobile POS.");
          setLoading(false);
          return;
        }

        localStorage.setItem("access_token", data.access);
        if (data.refresh) localStorage.setItem("refresh_token", data.refresh);

        let profile = { role: data.role, access_codes: data.role === "SUPERVISOR" ? [] : ["*"] };
        try {
          const meRes = await fetch(`${API_BASE}/api/me/`, {
            headers: { "Authorization": `Bearer ${data.access}` }
          });
          if (meRes.ok) {
            profile = await meRes.json();
            localStorage.setItem("user_profile", JSON.stringify(profile));
            updateFaviconAndTitle(profile);
          }
        } catch (e) {
          console.log("Profile fetch optional:", e);
          localStorage.setItem("user_profile", JSON.stringify(profile));
        }

        history.push(getDefaultLandingPath(profile));
      } else {
        setError(data.detail || data.error || "Identifiants invalides. Veuillez réessayer.");
      }
    } catch (err) {
      setError("Impossible de contacter le serveur backend. Vérifiez que Django est démarré.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-vh-100 d-flex align-items-center justify-content-center bg-soft p-3">
      <Container className="d-flex justify-content-center">
        <Card className="border-0 shadow-lg w-100" style={{ maxWidth: '420px', borderRadius: '12px' }}>
          {/* Modal Header */}
          <Card.Header className="bg-white border-bottom-0 pt-4 pb-2 text-center">
            <h4 className="fw-normal mb-0 text-dark">
              Fenetre de connexion
            </h4>
          </Card.Header>

          {/* Modal Body */}
          <Card.Body className="p-4 pt-3">
            {error && (
              <Alert variant="danger" className="py-2 text-center small mb-3">
                {error}
              </Alert>
            )}

            <Form onSubmit={handleSubmit}>
              {/* Identifiant Input */}
              <Form.Group className="mb-3" id="username">
                <Form.Control
                  autoFocus
                  required
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Identifiant"
                  style={{
                    border: '1px solid #EF4444',
                    borderRadius: '6px',
                    padding: '0.75rem 1rem',
                    fontSize: '0.95rem'
                  }}
                />
              </Form.Group>

              {/* Mot de passe Input */}
              <Form.Group className="mb-4" id="password">
                <Form.Control
                  required
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Mot de passe"
                  style={{
                    border: '1px solid #EF4444',
                    borderRadius: '6px',
                    padding: '0.75rem 1rem',
                    fontSize: '0.95rem'
                  }}
                />
              </Form.Group>

              {/* S'IDENTIFIER Button */}
              <Button
                type="submit"
                disabled={loading}
                className="w-100 text-uppercase font-weight-bold shadow-sm"
                style={{
                  backgroundColor: '#2D45FF',
                  borderColor: '#2D45FF',
                  padding: '0.65rem 1rem',
                  fontSize: '0.95rem',
                  borderRadius: '6px'
                }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    CONNEXION...
                  </>
                ) : (
                  "S'IDENTIFIER"
                )}
              </Button>
            </Form>

            {/* Slogan Footer */}
            <div className="mt-4 pt-3 border-top text-center">
              <p className="small text-muted mb-0 font-weight-bold">
                SGR Lotto <span className="fw-normal text-secondary">(Sistem paw la )</span>
              </p>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </main>
  );
};

